import React from 'react';
import { CircularProgress, Alert, Box } from '@mui/material';

/**
 * Reusable async state wrapper for loading/error/empty content.
 * Pass `loading`, `error`, `isEmpty` and optional `emptyMessage`.
 * Children render when not loading/error, regardless of emptiness unless `isEmpty` is true.
 */
const AsyncState = ({ loading, error, isEmpty, emptyMessage = 'No data available.', children }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ my: 1 }}>
        {error}
      </Alert>
    );
  }

  if (isEmpty) {
    return (
      <Alert severity="info" sx={{ my: 1 }}>
        {emptyMessage}
      </Alert>
    );
  }

  return <>{children}</>;
};

export default AsyncState;
